import { render, staticRenderFns } from "./MyLightBox.vue?vue&type=template&id=816bf79e&scoped=true&"
import script from "./MyLightBox.vue?vue&type=script&lang=js&"
export * from "./MyLightBox.vue?vue&type=script&lang=js&"
import style0 from "./MyLightBox.vue?vue&type=style&index=0&id=816bf79e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816bf79e",
  null
  
)

export default component.exports